/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ProjectRow = styled.tr({
  height: `${gridSize() * 4}px`,
  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    borderRadius: `${borderRadius()}px`,
  },
});

export const ProjectName = styled.div({
  padding: `${gridSize() / 2}px ${gridSize()}px`,
  '& a, & a:hover, & a:focus': {
    color: token('color.text'),
  },
});

export const ProjectDetailContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});
